<template>
	<section id="quotes" class="s-quotes">
		<div class="row section-header" data-aos="fade-up">
			<div class="col-full">
				<h3 class="subhead" v-html="$t('titles.quotesQuotes')"></h3>
				<h1 class="display-2" v-html="$t('texts.quotesInfo')"></h1>
			</div>
		</div>

		<WidgetQuotes/>
	</section>
</template>

<script>
	import WidgetQuotes from '../widgets/Quotes';
	export default {
		name: 'SectionQuotes',
		components: {WidgetQuotes}
	}
</script>


// WEBPACK FOOTER //
// src/components/sections/Quotes.vue